<template>
  <div class="modal-mask" @mousedown.self.stop="closeModal">
    <div class="modal" @click.stop>
      <div class="modal__head">
        <h3 class="modal__title">Редактировать информацию</h3>
        <div class="close" @click.stop="closeModal">
          <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 1L16 16" stroke="currentColor" stroke-width="2"/>
            <path d="M1 16L16 1" stroke="currentColor" stroke-width="2"/>
          </svg>
        </div>
      </div>
      <div class="modal__body">
        <div class="modal__row">
          <AppInput title="Имя"
                    :value="member.name"
                    :valid="{}"
                    @value-changed="setName"
          />
        </div>
        <div class="modal__row">
          <AppInput title="Фамилия"
                    :value="member.surname"
                    :valid="{}"
                    @value-changed="setSurname"
          />
        </div>
        <div class="modal__row">
          <AppInput title="Отчество"
                    :value="member.patronymic"
                    :valid="{}"
                    @value-changed="setPatronymic"
          />
        </div>
        <div class="modal__row">
          <AppSelect title="Степень родства"
                     placeholder="Укажите степень родства"
                     :value="member.kinship"
                     :options="kinshipList"
                     @value-changed="setKinship"
          />
        </div>
        <div class="modal__row">
          <AppInputDate title="Дата рождения"
                        :value="member.birth_at ? member.birth_at : ''"
                        type="single"
                        :valid="{}"
                        @value-changed="setBirthDate"
          />
        </div>
        <div class="modal__row mb-40">
          <AppInput title="Телефон"
                    :value="member.phone"
                    :valid="{}"
                    @value-changed="setPhone"
          />
        </div>
        <div class="modal__button-wrap">
          <div class="modal__button">
            <AppButton title="Сохранить" type="main" @click.native="updateMember"/>
          </div>
          <div class="modal__button">
            <AppButton title="Отмена" type="alt" @click.native="closeModal"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AppButton from '../button/AppButton.vue'
import AppInput from '../input/AppInput'
import AppSelect from '../input/AppSelect'
import AppInputDate from '@/components/page/input/AppInputDate'

export default {
  name: 'user-families-update-modal',
  components: {
    AppInputDate,
    AppSelect,
    AppInput,
    AppButton
  },
  props: {
    member: Object
  },
  computed: {
    kinshipList () {
      return this.$store.getters['[dictionaries] usersKinshipList']
    }
  },
  methods: {
    loadOptions () {
      this.$store.dispatch('[dictionaries] getKinshipList')
    },
    updateMember () {
      this.$store.dispatch('updateUserFamilyMember', this.member.id)
    },
    closeModal () {
      this.$emit('close-modal')
    },
    setName (name) {
      this.$store.dispatch('updateUserFamilyMemberName', name)
    },
    setSurname (surname) {
      this.$store.dispatch('updateUserFamilyMemberSurname', surname)
    },
    setPatronymic (patronymic) {
      this.$store.dispatch('updateUserFamilyMemberPatronymic', patronymic)
    },
    setKinship (kinship) {
      this.$store.dispatch('updateUserFamilyMemberKinship', kinship)
    },
    setBirthDate (date) {
      this.$store.dispatch('updateUserFamilyMemberBirthDate', date)
    },
    setPhone (phone) {
      this.$store.dispatch('updateUserFamilyMemberPhone', phone)
    }
  },
  mounted () {
    this.loadOptions()
  }
}
</script>

<style lang="scss" scoped>
@import '../../../assets/css/system/_vars';
@import '../../../assets/css/system/_mixins';

.modal-mask {
  align-items: flex-start;
  padding-top: 20px;
  padding-bottom: 100px;
  overflow: auto;
}

.modal {
  max-width: 500px;

  &__row {
    display: flex;
    flex-flow: row nowrap;
    width: 100%;
    margin-bottom: 20px;
  }

  &__text {
    text-align: center;
    color: $font_color_second;
    margin-bottom: 20px;
  }

  &__button-wrap {
    display: flex;
    flex-flow: row wrap;
    justify-content: center;
  }

  &__button {
    margin-right: 16px;
    margin-bottom: 10px;

    &:last-child {
      margin-right: 0;
    }
  }
}
</style>
